import React, { useState } from 'react';
import axios from 'axios';
import { Share2, Copy, Check, X } from 'lucide-react';

const API_URL = "";

const ShareButton = ({ dashboardType }) => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const generateLink = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/export-intelligence/share`, {
        type: dashboardType,
      }, { withCredentials: true });
      const fullUrl = `${window.location.origin}/shared/${res.data.token}`;
      setLink(fullUrl);
      setOpen(true);
    } catch (e) {
      console.error('Failed to generate share link', e);
    } finally {
      setLoading(false);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <button
        onClick={generateLink}
        disabled={loading}
        data-testid="share-button"
        style={{
          position: 'absolute',
          top: 12,
          right: 16,
          zIndex: 50,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: 'linear-gradient(135deg, #6366f1, #06b6d4)',
          color: '#fff',
          border: 'none',
          borderRadius: 10,
          padding: '8px 16px',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(99,102,241,0.3)',
          transition: 'transform 0.15s, box-shadow 0.15s',
        }}
        onMouseEnter={e => { e.target.style.transform = 'scale(1.04)'; e.target.style.boxShadow = '0 6px 20px rgba(99,102,241,0.4)'; }}
        onMouseLeave={e => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 16px rgba(99,102,241,0.3)'; }}
      >
        <Share2 size={15} />
        {loading ? 'Generating...' : 'Share'}
      </button>

      {open && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.5)',
            backdropFilter: 'blur(4px)',
          }}
          onClick={() => setOpen(false)}
        >
          <div
            onClick={e => e.stopPropagation()}
            data-testid="share-modal"
            style={{
              background: '#0e1c22',
              border: '1px solid #1e4049',
              borderRadius: 16,
              padding: 28,
              maxWidth: 480,
              width: '90%',
              boxShadow: '0 24px 48px rgba(0,0,0,0.4)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ color: '#eaf4f2', fontFamily: "'Hanken Grotesk', sans-serif", fontSize: 18, fontWeight: 700 }}>
                Share Dashboard
              </h3>
              <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', color: '#7e9aa0', cursor: 'pointer' }}>
                <X size={18} />
              </button>
            </div>

            <p style={{ color: '#7e9aa0', fontSize: 13, marginBottom: 16, lineHeight: 1.5 }}>
              Anyone with this link can view the dashboard — no login required.
            </p>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: '#081519',
              border: '1px solid #1e4049',
              borderRadius: 10,
              padding: '10px 12px',
            }}>
              <input
                type="text"
                readOnly
                value={link}
                data-testid="share-link-input"
                style={{
                  flex: 1,
                  background: 'none',
                  border: 'none',
                  color: '#4fc3c9',
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 12,
                  outline: 'none',
                  width: '100%',
                }}
              />
              <button
                onClick={copyLink}
                data-testid="copy-link-button"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  background: copied ? '#8fd694' : '#ff6b52',
                  color: copied ? '#081519' : '#240b06',
                  border: 'none',
                  borderRadius: 7,
                  padding: '7px 14px',
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  transition: 'background 0.2s',
                }}
              >
                {copied ? <><Check size={14} /> Copied!</> : <><Copy size={14} /> Copy</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareButton;
